import Vue from "vue";

const success = {
    namespaced: true,

    state: {
        showInviteModal : false,
        activeInvite : null,
        invites: []
    },

    getters: {
        getInvite: (state) => (index) => {
            if(typeof state.invites[index] !== 'undefined') {
                return state.invites[index];
            } else {
                return null;
            }
        },

        /*
        Retrieve the currently active invite
         */
        getActiveInvite: (state, getters) => {
            return getters.getInvite(state.activeInvite);
        },

        /*
        Retrieve whether the invite modal is open
         */
        getShowInviteModal : (state) => {
            return state.showInviteModal;
        },
    },

    mutations: {
        setInvites : (state, payload ) => {
            state.invites = payload;
        },

        updateInvite : (state, payload) => {
            for(let k in payload) {
                Vue.set(state.invites[state.activeInvite], k, payload[k]);
            }
        },

        /*
        Show the invite modal and fill content
         */
        showInviteModal : (state, payload) => {
            state.activeInvite = payload;
            state.showInviteModal = true;
        },

        /*
        Hide the invite modal and reset content
         */
        hideInviteModal : (state) => {
            state.showInviteModal = false;
            state.activeInvite = null;
        },
    }

};

export default success;
